<template>
  <v-card color="grey darken-4">
    <v-container fluid>
      <!-- The title -->
      <v-layout justify-center>
        <v-flex class="white--text display-1 font-weight-light" shrink>QMIs seleccionados</v-flex>
      </v-layout>
      <v-layout class="my-2">
        <v-flex>
          <v-divider />
        </v-flex>
      </v-layout>
      <!-- The items -->
      <v-layout v-if="groupedSelectedItems.length" justify-center wrap>
        <v-flex v-for="(item, index) in groupedSelectedItems" :key="index" xs12 sm4 md3 lg2 class="pa-2">
          <v-item-card
            class="my-1"
            comparison-dialog
            :item="item"
            no-color
            selectable
            vertical
            xs
          />
        </v-flex>
      </v-layout>
      <!-- The button to perform the creation of the QMP -->
      <v-layout class="my-2">
        <v-flex>
          <v-divider />
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-flex shrink>
          <v-create-qmp-btn @click="createProduct" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState, mapGetters } = createNamespacedHelpers("matching");

import VCreateQmpBtn from "./CreateQmpBtn";
import VItemCard from "../../components/ItemCard";

export default {
  components: {
    VCreateQmpBtn,
    VItemCard
  },
  computed: {
    ...mapState(["loadingProductCreation"]),
    ...mapGetters(["groupedSelectedItems"])
  },
  methods: {
    ...mapActions({
      createProductAction: "createProduct"
    }),
    createProduct() {
      return this.createProductAction({
        brand: this.$route.params.brandName,
        classificationId: this.$route.params.classificationId
      });
    }
  }
};
</script>